import { Spin, Table } from 'antd';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import {
  bool, object,
} from 'prop-types';
import { isEmpty, isNumber, isUndefined } from 'lodash';
import FilterType from '@/components/FilterType/FilterType';
import FilterTypeChild from '@/components/FilterType/FilterTypeChild';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getFacilityLoanPublicList } from '@/services/industryBankLoan';
import './PublicList.less';

const startYear = 2023;
const endYear = new Date().getFullYear(); // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});

/**
 * 产品列表组件
 * @param {object} data 数据源
 * @param {bool} isShow 是否显示按钮
 * @param {string} type 类型银行产品\保险产品
 * @param {bool} filter 是否显示筛选条件
 * */
export default function PublicList({
  data, filter,
}) {
  const { area } = data;
  const [list, setList] = useState({});
  const [val, setVal] = useState({});
  const [childArea, setChildArea] = useState([]);

  const { run, loading } = useRequest(getFacilityLoanPublicList, { // 保险产品
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    const { regionVo } = e;
    run({ ...e, ...regionVo });
  }

  function onChange(page, size) {
    getData({ ...val, pageNum: page, pageSize: size });
  }

  function filterArea(areaID) {
    const matched = area.filter((v) => v.id === areaID);
    const { children } = matched[0];
    return children;
  }

  function handleFilter(arr, t) {
    let obj = { ...val };
    if (t === 'cityCode' || t === 'areaCode') {
      if (t === 'cityCode') {
        if (arr) {
          const childrenArea = filterArea(arr[0]);
          setChildArea(childrenArea);
          obj = { ...obj, regionVo: { cityCode: arr[0] } };
        } else {
          // 全部城市则不需要参数
          setChildArea([]);
          obj = { ...obj, regionVo: {} };
        }
        setVal(obj);
        getData(obj);
      } else if (t === 'areaCode') {
        if (arr) {
          obj = { ...obj, regionVo: { ...obj.regionVo, areaCode: arr[0] } };
        } else {
          // 全部区县则只需要市级参数
          obj = { ...obj, regionVo: { cityCode: obj.regionVo.cityCode } };
        }
        setVal(obj);
        getData(obj);
      }
    } else {
      obj = { ...val, [t]: isUndefined(arr) ? null : arr[0] };
      setVal(obj);
      getData(obj);
    }
  }

  function tableTitle() {
    const { year } = val;

    return (
      <div style={{ fontSize: '20px', fontWeight: 600, textAlign: 'center' }}>
        {isNumber(year) ? `${year}年` : ''}
        农业产业化银行贷款贴息拟补助资金情况公告公示表
      </div>
    );
  }

  const columns = [
    {
      title: '市州',
      dataIndex: 'cityName',
      align: 'center',
      width: 100,
      fixed: 'left',
    },
    {
      title: '区县',
      dataIndex: 'areaName',
      align: 'center',
      width: 100,
      fixed: 'left',
    },
    {
      title: '企业（合作社名称）',
      dataIndex: 'declarationName',
      align: 'center',
    },
    {
      title: '核定贴息资金（万元）',
      align: 'center',
      children: [
        {
          title: '小计',
          dataIndex: 'totalAmount',
          align: 'center',
        },
        {
          title: '固定资产投资贷款',
          dataIndex: 'subsidyAmount1',
          align: 'center',
        },
        {
          title: '三大主粮流动资金贷款',
          dataIndex: 'subsidyAmount2',
          align: 'center',
        },
        {
          title: '油菜流动资金贷款',
          dataIndex: 'subsidyAmount3',
          align: 'center',
        },
        {
          title: '大豆流动资金贷款',
          dataIndex: 'subsidyAmount4',
          align: 'center',
        },
        {
          title: '畜禽养殖、屠宰精深加工',
          dataIndex: 'subsidyAmount8',
          align: 'center',
        },
        {
          title: '现代农业种业',
          dataIndex: 'subsidyAmount5',
          align: 'center',
        },
        {
          title: '现代农业烘干冷链物流',
          dataIndex: 'subsidyAmount6',
          align: 'center',
        },
        {
          title: '农机',
          dataIndex: 'subsidyAmount7',
          align: 'center',
        },
      ],
    },
    {
      title: '公示单位联系电话',
      dataIndex: 'publicationTel',
      align: 'center',
      fixed: 'right',
    },
  ];

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        <span className="pl-filter-title">筛选条件</span>
        {
          filter && (
            <div className="product-filter">

              <FilterType title="申报年度" titleWidth={88} data={years} radio onChange={(e) => handleFilter(e, 'year')} />
              {
                !isEmpty(data?.area) && (
                  <FilterType title="申报区域" titleWidth={88} data={data?.area} radio onChange={(e) => handleFilter(e, 'cityCode')} />
                )
              }
              {
                !isEmpty(childArea) && (
                  <FilterTypeChild title="" data={childArea} radio onChange={(e) => handleFilter(e, 'areaCode')} />
                )
              }
            </div>
          )
        }
        <span className="pl-list-title">情况公示</span>
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              <Table
                title={tableTitle}
                columns={columns}
                rowKey="id"
                dataSource={list?.items}
                scroll={{ x: 1500 }}
                pagination={{
                  onChange,
                  current: list?.pageNum,
                  total: list?.totalRows,
                }}
              />
            </div>
          )
        }
      </Spin>
    </div>
  );
}

PublicList.propTypes = {
  filter: bool,
  data: object,
};

PublicList.defaultProps = {
  filter: true,
};
